import { defineComponent as _defineComponent } from 'vue'
import { DataInstance } from '@busy-human/gearbox';
import { InviteLinks } from '@busy-human/opt-library'
import Loader from '@/components/loader.vue';
import { computed, ref } from 'vue'

type Props = {
    instance: any
    error: string | null
}
type Emits = {
    (e: 'progress'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'referral-send',
  props: {
    instance: null,
    error: null
  },
  emits: ["progress"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'progress'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    instance: any
    error: string | null
}





const noScroll = ref(false)

const referralURL = ref('opt.com/FakeReferralURL')

const progress = () => {
    emit('progress');
}

const referralLink = ref()

const copyToClipboard = () =>{
    referralLink.value.focus()
    referralLink.value.select()
    document.execCommand('copy');
}



const __returned__ = { props, emit, noScroll, referralURL, progress, referralLink, copyToClipboard, DataInstance, InviteLinks, Loader, computed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})